<template>
  <div class="tabs-container">
    <v-tabs v-model="tab" class="d-flex tabs-sub-page" :show-arrows="true">
      <v-tab
        :to="!isPreview ? `/page/${parentUrlKey}/${tab.urlKey}` : `/preview/${tab.urlKey}`"
        v-for="(tab, index) in model.content"
        :key="index"
      >
        <span class="tab-title">{{ tab.title }}</span>
      </v-tab>
    </v-tabs>
    <keep-alive>
      <router-view
        class="tabs-sub-page"
        page-type="page"
        :key="key"
      ></router-view>
    </keep-alive>
  </div>
</template>
<script>

export default {
  name: 'TabsSubPage',
  props: ['model'],
  data: () => ({
    tabs: [],
    tab: null
  }),
  created() {
    this.parentUrlKey = this.model.parent.urlKey
    if (this.isPreview) {
      this.$router.push({ name: 'subDynamicPreview', params: { subUrlKey: this.model.content[0].urlKey } })
    }
    if (this.$route.params != null && this.$route.params.subUrlKey == null) {
      this.$router.replace({
        name: 'subDynamic',
        params: {
          urlKey: this.parentUrlKey,
          subUrlKey: this.model.content[0].urlKey
        }
      })
    }
  },
  computed: {
    key() {
      return new Date().getTime()
    },
    isPreview() {
      return this.model.parent.type === 'preview'
    }
  }
}
</script>
<style lang="scss">
@import '@/scss/main.scss';
.tabs-container .tabs-sub-page {
  @include page-content-style;
}

@media #{map-get($display-breakpoints, 'md-and-down')} {
  .tabs-container .tabs-sub-page > .content-wrapper.standart > .content {
    margin: 2rem $xl-indent;
  }
}

@media #{map-get($display-breakpoints, 'xs-only')} {
  .tabs-container .tabs-sub-page > .content-wrapper.standart > .content {
    margin: 2rem $xs-indent;
  }
}

@media #{map-get($display-breakpoints, 'md-and-up')} {
  .tabs-sub-page > .v-slide-group.v-tabs-bar {
    padding: 0 $xl-indent;
  }
}

div.tabs-container.content {
  padding-top: 0 !important;
  max-width: none !important;
  margin: 0 !important;

  .tab-title {
    font-size: 1.6rem;
  }

  .tabs-sub-page-groups {
    background-color: inherit;
  }

  .v-tabs-items {
    .v-window__container,
    .tab-page-container {
      height: 100%;
    }

    .page-container {
      display: flex;
      flex-direction: column;
    }
  }
  .v-tab {
    font-size: 1.4rem;
    text-transform: none;
    letter-spacing: 0;
  }
}
</style>
